import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    AccountPageFragment,
    GetAccount as GetAccountQuery,
    GetAccountVariables,
} from 'nutshell-graphql-types';

import GET_ACCOUNT from '../queries/get-account.graphql';

export function useGetAccount(
    accountId: string,
    skip: boolean = false
): {
    account: AccountPageFragment | null;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<GetAccountQuery, GetAccountVariables>(
        GET_ACCOUNT,
        {
            variables: {id: accountId},
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network',
            skip,
        }
    );

    return {
        account: data?.account ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
